import axios from "axios";
import Cookies from "js-cookie";
const logInStatus = parseInt(Cookies.get("Role"));
const secretToken = Cookies.get("token");

export const API = axios.create({
  // baseURL: "http://192.168.3.7:7000/api/v1/",
  // baseURL: "https://store.projmantech.com/api/v1/",
  baseURL: "https://inventory.infotechitsolutionsbd.com/api/v1/",
  // baseURL: "https://192.168.168.117:8000/api/v1/",
  // baseURL: "https://192.168.3.18:8000/api/v1/",
  // baseURL: "http://localhost:8000/api/v1/",

  timeout: 100000,
  headers: {
    role_id: logInStatus,
    Authorization: `Bearer ${secretToken}`,
    // Authorization: `Bearer `,
    "Content-Type": "application/json",
  },
  withCredentials: true
});

